import React from 'react';
import { FiGlobe, FiAward, FiTrendingUp, FiCheck } from 'react-icons/fi';
import { Container } from '../../components/layout/Container';

const TimelineItem = ({ highlight, index, total }) => {
  // Determine icon based on content (simple heuristic)
  let Icon = FiCheck;
  if (highlight.includes('2022')) Icon = FiTrendingUp;
  if (highlight.includes('ABD')) Icon = FiGlobe;
  if (highlight.includes('IATA')) Icon = FiAward;

  return (
    <div className="relative pl-8 sm:pl-12 py-6 group">
      {/* Connector Line */}
      {index !== total - 1 && (
        <div className="absolute left-[11px] sm:left-[15px] top-8 bottom-0 w-0.5 bg-gray-200 group-hover:bg-primary/30 transition-colors" />
      )}

      {/* Dot */}
      <div className="absolute left-0 top-6 w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-white border-2 border-primary flex items-center justify-center z-10 shadow-sm group-hover:scale-110 transition-transform duration-300">
        <Icon className="w-3 h-3 sm:w-4 sm:h-4 text-primary" />
      </div>

      {/* Content Card */}
      <div className="bg-white p-5 sm:p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300 transform hover:-translate-y-1">
        <p className="text-gray-700 font-medium leading-relaxed">
          {highlight}
        </p>
      </div>
    </div>
  );
};

/**
 * Story section component for About page with Timeline design
 */
export const StorySection = ({ story }) => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white overflow-hidden relative" aria-labelledby="story-title">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-primary/5 rounded-bl-[100px] opacity-60 pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-secondary/5 rounded-tr-[80px] opacity-40 pointer-events-none" />

      <Container className="relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-stretch">

          {/* Left Column: Narrative */}
          <div className="flex flex-col justify-center">
            <span className="text-primary font-bold tracking-wider uppercase text-sm mb-3 block">
              Global Journey
            </span>
            <h2 id="story-title" className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-gray-900 mb-6">
              {story.title}
            </h2>
            <div className="prose prose-lg text-gray-600 leading-relaxed mb-8">
              <p>
                {story.content}
              </p>
            </div>


          </div>

          {/* Right Column: Timeline */}
          <div className="relative">
            {story.highlights.map((highlight, index) => (
              <TimelineItem
                key={index}
                highlight={highlight}
                index={index}
                total={story.highlights.length}
              />
            ))}
          </div>

        </div>
      </Container>
    </section>
  );
};
